import Vue from "vue";
import router from "../router";
import md5 from "js-md5";
import { Message, MessageBox, Loading } from "element-ui";
import fanyi from "./language";
import OSS from "ali-oss";
import apis from "../api/apis";
// 分类自定义路由工具：路径生成、动态路由构建、路由类型判断
import {
  getShopGroupCategoryPath,
  findCategoryPathInShopGroup,
  isShopGroupRoute,
  isCommoditySearchRoute,
} from "./shopGroupRoute";

let timeout = null; // 创建一个标记用来存放定时器的返回值
let canRun = true;

// 页面跳转被浏览器拦截时提示（routerToPage 内调用）
// warnNavigateBlocked - 跳转拦截提示
function warnNavigateBlocked() {
  Message.warning(fanyi("浏览器已拦截页面跳转，请允许本站跳转后重试"));
}

// 判断是否为商品搜索相关跳转（CommoditySearch 及分类搜索路由）
// isCommoditySearchNavigateUrl - 是否商品搜索跳转地址
function isCommoditySearchNavigateUrl(url) {
  if (typeof url !== "string") return false;
  return (
    url.includes("/CommoditySearch") ||
    url.includes("CommoditySearch?") ||
    url.includes("type=imgSearch")
  );
}

const specifiedFormatDate = (timer) => {
  var date = new Date();
  if (timer.date) {
    var date = new Date(timer.date);
  }
  if (date == "Invalid Date") {
    const regehms = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/;
    const regehm = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}$/;
    const str = timer.date;
    const isValidFormat = regehms.test(str) || regehm.test(str);
    if (isValidFormat) {
      let year = timer.date.substr(0, 4);
      let month = timer.date.substr(5, 2);
      let day = timer.date.substr(8, 2);
      let hour = timer.date.substr(11, 2);
      let minu = timer.date.substr(14, 2);
      let sec = timer.date.substr(17, 2) || "00";
      if (timer.format) {
        return timer.format
          .replace("yyyy", year)
          .replace("mm", month)
          .replace("dd", day)
          .replace("hh", hour)
          .replace("min", minu)
          .replace("ss", sec);
      }
      return date.getFullYear() + "-" + month + "-" + day;
    } else {
      return timer.date;
    }
  }
  var month = parseInt(date.getMonth() + 1);
  var day = date.getDate();
  var hour = date.getHours();
  var minu = date.getMinutes();
  var sec = date.getSeconds();

  if (month < 10) month = "0" + month.toString() || "0";
  if (day < 10) day = "0" + day.toString() || "0";
  if (hour < 10) hour = "0" + hour.toString() || "0";
  if (minu < 10) minu = "0" + minu.toString() || "0";
  if (sec < 10) sec = "0" + sec.toString() || "0";

  if (timer.format) {
    return timer.format
      .replace("yyyy", date.getFullYear())
      .replace("mm", month)
      .replace("dd", day)
      .replace("hh", hour)
      .replace("min", minu)
      .replace("ss", sec);
  }
  return date.getFullYear() + "-" + month + "-" + day;
};

const getRandomNumber = (max, min) => {
  let x = Math.floor(Math.random() * (max - min + 1)) + min;
  return x;
};

import store from "../store/index";

/** /ProductDetails?goods_id=…&shopType=…&extra，extra 如 LP=xxx（已编码则直接拼）；from_platform 可为含 from_platform 等字段的对象 */
const buildProductDetailsPath = (goods_id, from_platform, extraQueryString) => {
  let from_platform_value = "";

  if (typeof from_platform === "object" && from_platform !== null) {
    from_platform_value =
      from_platform.from_platform ||
      from_platform.shop_type ||
      from_platform.shopType ||
      from_platform.fromPlatform ||
      "";
  } else if (from_platform != null && String(from_platform).trim() !== "") {
    from_platform_value = from_platform;
  }

  let url = "/ProductDetails?goods_id=" + goods_id;
  if (from_platform_value !== "") {
    url += "&shopType=" + encodeURIComponent(String(from_platform_value));
  }
  if (extraQueryString != null && String(extraQueryString).trim() !== "") {
    const s = String(extraQueryString).replace(/^&+/, "");
    if (s) url += "&" + s;
  }
  return url;
};

let data = {
  // 打开聊天窗口
  chat(chat) {
    if (store.state.userInfo) {
      let iTop = (window.screen.availHeight - 30 - 700) / 2;
      //获得窗口的水平位置
      let iLeft = (window.screen.availWidth - 10 - 1260) / 2;
      if (chat == 1) {
        // user 传 user_id 的 MD5；商品详情页额外带 url 参数
        const userIdMd5 = md5(String(store.state.userInfo.user_id || ""));
        data.routerToPage(
          `https://chat.rakumart.it/#/?id=${
            store.state.userInfo.user_id
          }&user=${userIdMd5}${
            location.href.indexOf("ProductDetails") != -1
              ? "&url=" + location.href
              : ""
          }`,
          true
        );
        // window.open(
        //   "https://chat.rakumart.it/#/?id=" +
        //     store.state.userInfo.user_id,
        //   store.state.userInfo,
        //   "height=700, width=1260, left=" +
        //     iLeft +
        //     ", top=" +
        //     iTop +
        //     ", toolbar=no, menubar=no, scrollbars=yes, resizable=no, location=no, status=no"
        // );
      } else {
        data.routerToPage(
          store.state.userInfo.whatsapp
            ? store.state.userInfo.whatsapp
            : "https://api.whatsapp.com/send/?phone=393762669726",
          true
        );
        // window.open(
        //   store.state.userInfo.whatsapp
        //     ? store.state.userInfo.whatsapp
        //     : "https://wa.me/+393762669726",
        //   "WhatsApp",
        //   "height=700, width=1260, left=" +
        //     iLeft +
        //     ", top=" +
        //     iTop +
        //     ", toolbar=no, menubar=no, scrollbars=yes, resizable=yes, location=no, status=no"
        // );
      }
    } else {
      store.commit("getshowLoginDialog", true);
    }
  },
  productDetailsPath: buildProductDetailsPath,
  /**
   * @param {string|number} goods_id
   * @param {object|string} [formSource] 整行商品/订单对象（解析 form），或 { from_platform }，或 form 字符串
   * @param {string} [extraQueryString] 附加 query，与 productDetailsPath 第三参一致
   */
  toCommodityDetails: (goods_id, formSource, extraQueryString) => {
    window.open(
      buildProductDetailsPath(goods_id, formSource, extraQueryString),
      "_blank"
    );
  },
  toPage: (url) => {
    location.href = url;
  },
  // 打开外部链接
  clickJs() {
    // let element = document.getElementById("zsiq_float");
    // // 创建事件
    // var event = document.createEvent("MouseEvents");
    // // 定义事件 参数： type, bubbles, cancelable
    // event.initEvent("click", true, true);
    // // 触发对象可以是任何元素或其他事件目标
    // element.dispatchEvent(event);
    data.chat(1);
  },
  setUserID() {
    let str = `rakumartsp-${(store.state.userInfo || {}).user_id}`;
    // console.log(str);
    return md5(str);
  },

  routerToPage: (url, isBlank) => {
    if (isBlank) {
      const page = window.open("about:blank");
      // 商品搜索等新标签跳转被拦截时提示用户
      if (!page) {
        if (isCommoditySearchNavigateUrl(url)) {
          warnNavigateBlocked();
        }
        return;
      }
      try {
        page.location.href = url;
      } catch (e) {
        if (isCommoditySearchNavigateUrl(url)) {
          warnNavigateBlocked();
        }
      }
    } else {
      location.href = url;
    }
  },
  unique: (arr) => {
    //数组去重
    return Array.from(new Set(arr));
  },
  //去除一个数组中与另一个数组中的值相同的元素
  quChu: (a, b) => {
    //数组去重
    let c = [];
    for (let i of a) {
      if (b.indexOf(i) === -1) {
        c.push(i);
      }
    }
    return c;
  },
  //   将数组转换为onum个一组
  changeArr: (oarr, onum) => {
    const arr = oarr;
    const len = arr.length;
    let result = [];
    const sliceNum = onum; // 这个值代表几个一组

    for (let i = 0; i < len / sliceNum; i++) {
      result.push(arr.slice(i * sliceNum, (i + 1) * sliceNum));
    }
    // 补足不足onum个的最后一个数组
    // for(let j = 0; j < (sliceNum - len % sliceNum); j++) {
    //     result[result.length - 1].push({})
    // }

    return result;
  },
  /**
   * 函数防抖
   * 触发事件后在n秒后执行，如果n秒内又触发事件，则重新计算时间
   */
  debounce(fn, wait = 1000) {
    let timer;
    return function() {
      let context = this;
      let args = arguments;
      if (timer) clearTimeout(timer);
      timer = setTimeout(() => {
        fn.apply(context, args);
      }, wait);
    };
  },

  /**
   * 函数节流
   * 触发事件立即执行，但在n秒内连续触发则不执行
   */
  throttle(fn, wait, options = {}) {
    let timer;
    let previous = 0;
    let throttled = function() {
      let now = +new Date();
      // remaining 不触发下一次函数的剩余时间
      if (!previous && options.leading === false) previous = now;
      let remaining = wait - (now - previous);
      if (remaining < 0) {
        if (timer) {
          clearTimeout(timer);
          timer = null;
        }
        previous = now;
        fn.apply(this, arguments);
      } else if (!timer && options.trailing !== false) {
        timer = setTimeout(() => {
          previous = options.leading === false ? 0 : new Date().getTime();
          timer = null;
          fn.apply(this, arguments);
        }, remaining);
      }
    };
    return throttled;
  },
  //   加密字符串
  toCode(str) {
    //加密字符串
    //定义密钥，36个字母和数字
    var key = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    var l = key.length; //获取密钥的长度
    var a = key.split(""); //把密钥字符串转换为字符数组
    var s = "",
      b,
      b1,
      b2,
      b3; //定义临时变量
    for (var i = 0; i < str.length; i++) {
      //遍历字符串
      b = str.charCodeAt(i); //逐个提取每个字符，并获取Unicode编码值
      b1 = b % l; //求Unicode编码值得余数
      b = (b - b1) / l; //求最大倍数
      b2 = b % l; //求最大倍数的于是
      b = (b - b2) / l; //求最大倍数
      b3 = b % l; //求最大倍数的余数
      s += a[b3] + a[b2] + a[b1]; //根据余数值映射到密钥中对应下标位置的字符
    }
    return s; //返回这些映射的字符
  },
  // 解密字符串
  fromCode(str) {
    if (!str) return str;
    //定义密钥，36个字母和数字
    var key = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    var l = key.length; //获取密钥的长度
    var b,
      b1,
      b2,
      b3,
      d = 0,
      s; //定义临时变量
    s = new Array(Math.floor(str.length / 3)); //计算加密字符串包含的字符数，并定义数组
    b = s.length; //获取数组的长度
    for (var i = 0; i < b; i++) {
      //以数组的长度循环次数，遍历加密字符串
      b1 = key.indexOf(str.charAt(d)); //截取周期内第一个字符串，计算在密钥中的下标值
      d++;
      b2 = key.indexOf(str.charAt(d)); //截取周期内第二个字符串，计算在密钥中的下标值
      d++;
      b3 = key.indexOf(str.charAt(d)); //截取周期内第三个字符串，计算在密钥中的下标值
      d++;
      s[i] = b1 * l * l + b2 * l + b3; //利用下标值，反推被加密字符的Unicode编码值
    }
    b = eval("String.fromCharCode(" + s.join(",") + ")"); //用fromCharCode()算出字符串
    return b; //返回被解密的字符串
  },
  // 将数字四舍五入，传入参数:数字，小数位数
  roundNumber(Num, wei) {
    return Number(Num.toFixed(wei));
  },
  // ceil(num, fix) {
  //     let result = '0'
  //     if (typeof num === 'number' && !isNaN(num)) {
  //         if (!fix) {
  //             fix = 2
  //         }
  //         // num为原数字，fix是保留的小数位数
  //         if (Number(num) && fix > 0) { // 简单的做个判断
  //             fix = +fix || 2
  //             num = num + ''
  //             if (/e/.test(num)) { // 如果是包含e字符的数字直接返回
  //                 result = num
  //             } else if (!/\./.test(num)) { // 如果没有小数点
  //                 // result = num + `.${Array(fix + 1).join('0')}`
  //             } else { // 如果有小数点
  //                 num = Math.round(num * ((fix + 1) ** 10)) / ((fix + 1) ** 10);
  //                 num = num + `${Array(fix + 1).join('0')}`
  //                 let reg = new RegExp(`-?\\d*\\.\\d{0,${fix}}`)
  //                 let floorStr = reg.exec(num)[0]
  //                 if (+floorStr >= +num) {
  //                     result = floorStr
  //                 } else {
  //                     let floorNumber = +floorStr + +`0.${Array(fix).join('0')}1`
  //                     let point = /\./.test(floorNumber + '') ? '' : '.'
  //                     let floorStr2 = floorNumber + point + `${Array(fix + 1).join('0')}`
  //                     result = reg.exec(floorStr2)[0]
  //                 }
  //             }
  //         }
  //     }
  //     return result
  // },
  // // 将数字向上取整n位
  ceil(num, precision) {
    if (!precision || precision < 0) {
      precision = 2;
    }
    if (typeof num === "number" && !isNaN(num)) {
      const factor = Math.pow(10, precision);
      return Math.ceil(num * factor) / factor;
    }
    return num;
  },
  // 跳转到指定元素，传入元素的ref或者id，如this.$refs.hfdh
  maoDian(element, orderHeight) {
    let toTop = element.offsetTop;
    if (orderHeight) {
      toTop = element.offsetTop + orderHeight;
    }
    window.scrollTo(0, toTop);
  },
  downloadIamge(imgsrc, name) {
    // 下载图片地址和图片名
    var image = new Image();
    // 解决跨域 Canvas 污染问题
    image.setAttribute("crossOrigin", "anonymous");
    image.onload = function() {
      var canvas = document.createElement("canvas");
      canvas.width = image.width;
      canvas.height = image.height;
      var context = canvas.getContext("2d");
      context.drawImage(image, 0, 0, image.width, image.height);
      var url = canvas.toDataURL("image/png"); // 得到图片的base64编码数据
      var a = document.createElement("a"); // 生成一个a元素
      var event = new MouseEvent("click"); // 创建一个单击事件
      a.download = name || "photo"; // 设置图片名称
      a.href = url; // 将生成的URL设置为a.href属性
      a.dispatchEvent(event); // 触发a的单击事件
    };
    image.src = imgsrc;
  },
  // 把价格两位小数后的文字缩小
  twoSmall(value, fontSize) {
    //console.log(value, value % 1 > 0);
    if (value % 1 > 0) {
      let arr = value.toString().split(",");
      return "<font>" + arr[0] + ".</font><font style='font-size:'" + fontSize
        ? fontSize
        : "20" + "'px'>" + arr[1] + "</font>";
    }
    return value;
  },
  // 欧元价格千分位
  EURNumSegmentation(Num) {
    if (!Num) {
      if (Num == 0) {
        return 0;
      }
      return "";
    }

    const n = Number(Num);
    if (Number.isNaN(n)) {
      return "";
    }
    const numStr = Number.isInteger(n) ? String(Math.trunc(n)) : String(n);

    let re = /\d(?=(?:\d{3})+\b)/g;
    let num = numStr.replace(/\./g, ",");
    num = String(num).replace(re, "$&.");
    return num;
  },
  huilvqianf(Num) {
    // let num = String(Num).replace(/./, ',')
    let num = String(Num).replace(/\./g, ",");
    return num;
  },
  // 人民币价格千分位
  RMBNumSegmentation(Num) {
    if (!Num) {
      if (Num == 0) {
        return 0;
      }
      return "";
    }

    const n = Number(Num);
    if (Number.isNaN(n)) {
      return "";
    }
    const numStr = Number.isInteger(n) ? String(Math.trunc(n)) : String(n);

    let re = /\d(?=(?:\d{3})+\b)/g;
    let num = numStr.replace(/\./g, ",");
    num = String(num).replace(re, "$&.");
    return num;
  },
  /* 防抖节流函数 */

  //!!!!这里一定要把变量设在外面，不然会失效！我搞了好久才搞明白！
  debounce(fn) {
    return function() {
      clearTimeout(timeout); // 每当用户输入的时候把前一个 setTimeout clear 掉
      timeout = setTimeout(() => {
        // 然后又创建一个新的 setTimeout, 这样就能保证输入字符后的 interval 间隔内如果还有字符输入的话，就不会执行 fn 函数
        fn.apply(this, arguments);
      }, 2000);
    };
  },
  throttle(fn) {
    return function() {
      if (!canRun) return;
      canRun = false;
      setTimeout(function() {
        fn.apply(this, arguments);
        canRun = true;
      }, 3000);
    };
  },
  isArray(arg) {
    if (typeof Array.isArray === "undefined") {
      return Object.prototype.toString.call(arg) === "[object Array]";
    }
    return Array.isArray(arg);
  },
  // 深度克隆
  deepClone(obj) {
    // 对常见的“非”值，直接返回原来值
    if ([null, undefined, NaN, false].includes(obj)) return obj;
    if (typeof obj !== "object" && typeof obj !== "function") {
      //原始类型直接返回
      return obj;
    }
    var o = data.isArray(obj) ? [] : {};
    for (let i in obj) {
      if (obj.hasOwnProperty(i)) {
        o[i] = typeof obj[i] === "object" ? this.deepClone(obj[i]) : obj[i];
      }
    }
    return o;
  },
  //将相同skuId的数量进行重置
  mergeArrayValue(arr) {
    let end = [];
    end.push(arr[0]);
    if (arr.length > 0) {
      for (let i = 1; i < arr.length; i++) {
        arr[i].num = Number(arr[i].num);
        let j = 0;
        for (; j < end.length; j++) {
          // 6. 判断两个数组中的id是否相同
          if (arr[i].skuId === end[j].skuId) {
            // 7.相等就将我们比较的对象 `arr[i]` 存储到  相同id对象的list 中
            end[j].num = arr[i].num;
            // *** 8.这里要理解，我们每次遍历，其实都是处理  `arr[i]` ，而上面的逻辑已经处理了，所以终止后续的循环 break;
            break;
          }
        }
        if (j === end.length) {
          end.push(arr[i]);
        }
      }
    }
    return end;
  },
  // 将每个单词首字母转换成大写
  trunUpperCase(v) {
    if (v)
      return v
        .trim()
        .toLowerCase()
        .replace(/( |^)[a-z]/g, (L) => L.toUpperCase());
  },
  //意大利时间
  timeE(v) {
    if (v)
      return (
        v.substr(8, 2) +
        "-" +
        v.substr(5, 2) +
        "-" +
        v.substr(0, 4) +
        " " +
        v.substr(10)
      );
  },
  // js模拟点击
  emulateMouseClick(element) {
    // 创建事件
    var event = document.createEvent("MouseEvents");
    // 定义事件 参数： type, bubbles, cancelable
    event.initEvent("click", true, true);
    // 触发对象可以是任何元素或其他事件目标
    element.dispatchEvent(event);
  },
  // 关闭页面
  exitOperation() {
    alert("操作id与token不匹配,将关闭此页面");
    window.close();
    setTimeout(() => {
      window.close();
    }, 5000);
  },

  // 获取星期
  getWeekDay(date) {
    const weekdays = [
      "星期日",
      "星期一",
      "星期二",
      "星期三",
      "星期四",
      "星期五",
      "星期六",
    ];
    if (!date) {
      date = new Date();
    } else if (typeof date === "string") {
      date = new Date(date);
    }
    return weekdays[date.getDay()];
  },

  // 寻找值对应的名字
  findName(list, value, in_data) {
    let odata = in_data || {};
    if (!Array.isArray(list)) {
      console.log("list不是数组", list);
      return value;
    }
    for (let i = 0; i < list.length; i++) {
      if (list[i][odata.valueName || "value"] == value) {
        return list[i][odata.keyName || "key"];
      }
    }
    return value;
  },
  // 寻找值对应的下标
  findNo(list, value, in_data) {
    let odata = in_data || {};
    if (!Array.isArray(list)) {
      console.log("list不是数组", list);
      return value;
    }
    for (let i = 0; i < list.length; i++) {
      if (list[i][odata.findName || "key"] == value) {
        return i;
      }
    }
    return value;
  },
  // 寻找名字对应的值
  findValue(list, value, in_data) {
    let odata = in_data || {};
    if (!Array.isArray(list)) {
      console.log("list不是数组", list);
      return null;
    }
    for (let i = 0; i < list.length; i++) {
      if (list[i][odata.keyName || "key"] == value) {
        return list[i][odata.valueName || "value"];
      }
    }
    return null;
  },
  // 检查参数是否为空
  checkParams(value) {
    if (value === "" || value === undefined || value === null) {
      return false;
    }
    return true;
  },
  // 限制只能输入正整数
  //因为 el-input type='number'的时候输入小数点会先不调用oninput,所以不能和type='number'一起用
  rejectIntNumbers(e) {
    // 原生返回target
    if (e.target) {
      e.target.value = e.target.value.replace(/[^\d]/g, "");
    }
    // el-input 返回的是srcElement参数
    if (e.srcElement) {
      e.srcElement.value = e.srcElement.value.replace(/[^\d]/g, "");
    }
  },

  imgPreview(url) {
    const image = new Image();
    image.src = url;
    image.onload = () => {
      // 创建弹出层
      const previewContainer = document.createElement("div");
      previewContainer.style.position = "fixed";
      previewContainer.style.top = 0;
      previewContainer.style.bottom = 0;
      previewContainer.style.left = 0;
      previewContainer.style.right = 0;
      previewContainer.style.zIndex = 9999;
      previewContainer.style.backgroundColor = "rgba(0,0,0,0.8)";
      previewContainer.style.display = "flex";
      previewContainer.style.justifyContent = "center";
      previewContainer.style.alignItems = "center";
      document.body.appendChild(previewContainer);

      // 在弹出层增加图片
      const previewImage = document.createElement("img");
      previewImage.src = image.src;
      previewImage.style.maxWidth = "80vw";
      previewImage.style.maxHeight = "80vh";
      previewImage.style.zIndex = 9999;
      previewImage.style.transform = "scale(1)";
      previewImage.style.transition = "transform 0.2s";
      previewContainer.appendChild(previewImage);

      let scale = 1;

      // 鼠标滚轮缩放
      previewImage.addEventListener("wheel", (e) => {
        e.preventDefault();
        const delta = e.deltaY || e.detail || e.wheelDelta;
        if (delta > 0) {
          scale = Math.max(0.1, scale - 0.1);
        } else {
          scale = Math.min(10, scale + 0.1);
        }
        previewImage.style.transform = `scale(${scale})`;
      });

      // 点击弹出层关闭预览（点击图片不关闭）
      previewContainer.addEventListener("click", (e) => {
        if (e.target === previewContainer) {
          document.body.removeChild(previewContainer);
        }
      });
    };
    image.onerror = function() {
      console.log("图片加载失败");
    };
  },

  httpRequest(file, ImSuccess, showLoading = true) {
    // 新上传文件

    let size = file.size;
    var loadingInstance = null;
    if (showLoading) {
      loadingInstance = Loading.service({
        lock: true,
        text: "上传中",
      });
      setTimeout(() => {
        loadingInstance.close();
      }, 15000);
    }
    apis.esOssUploadToken().then((tokenres) => {
      ////console.log('事件名',res)
      if (tokenres.code != 0) return Message.error(tokenres.msg);
      //接下来的操作
      let upToken = tokenres.data;
      let rawname = file.name.split(".")[1];
      let abortCheckpoint;
      let fileUp = new OSS({
        // region填写Bucket所在地域。以华东1（杭州）为例，Region填写为oss-cn-hangzhou。
        region: "oss-cn-hangzhou",
        // 从STS服务获取的临时访问密钥（AccessKey ID和AccessKey Secret）。
        accessKeyId: upToken.AccessKeyId,
        accessKeySecret: upToken.AccessKeySecret,
        // 从STS服务获取的安全令牌（SecurityToken）。
        stsToken: upToken.SecurityToken,
        refreshSTSToken: async () => {
          // 向您搭建的STS服务获取临时访问凭证。
          const info = await fetch("your_sts_server");
          return {
            accessKeyId: info.accessKeyId,
            accessKeySecret: info.accessKeySecret,
            stsToken: info.stsToken,
          };
        },
        // 刷新临时访问凭证的时间间隔，单位为毫秒。
        refreshSTSTokenInterval: 300000,
        // 填写Bucket名称。
        bucket: "rakumart-test",
        // 是否使用HTTPS
        secure: true,
      });

      if (size > 1000000) {
        //这是分片上传
        fileUp
          .multipartUpload(
            `${specifiedFormatDate({
              format: "yyyymmddhhminss",
            })}${getRandomNumber(10000, 999999)}.${rawname}`,
            file,
            {
              progress: (p, cpt, res) => {
                // 为中断点赋值。
                abortCheckpoint = cpt;

                // 获取上传进度。
                console.log("progress=====", p);
              },
            }
          )
          .then((imgOBJ) => {
            // console.log(imgOBJ);
            // .split("?")[0]是为了去掉oss返回链接上自动加的uploadId参数
            imgOBJ.res.data = imgOBJ.res.requestUrls[0].split("?")[0];
            if (loadingInstance) loadingInstance.close();
            ImSuccess(imgOBJ.res, file);
          });
      } else {
        //这是简单上传
        fileUp
          .put(
            `${specifiedFormatDate({
              format: "yyyymmddhhminss",
            })}${getRandomNumber(10000, 999999)}.${rawname}`,
            file
          )
          .then((imgOBJ) => {
            // console.log(imgOBJ);
            // .split("?")[0]是为了去掉oss返回链接上自动加的uploadId参数
            imgOBJ.res.data = imgOBJ.res.requestUrls[0].split("?")[0];
            if (loadingInstance) loadingInstance.close();
            ImSuccess(imgOBJ.res, file);
          });
      }
    });
  },

  // --- 商品分类自定义路由（详见 shopGroupRoute.js）---
  getShopGroupCategoryPath, // 生成分类完整路径
  findCategoryPathInShopGroup, // 在分类树中查找并返回路径
  isShopGroupRoute, // 是否为动态注册的分类路由
  isCommoditySearchRoute, // 是否为商品搜索页（含 /CommoditySearch 与分类路由）
  /** 跳转到分类自定义路由（一级传 category，二级需传 ancestors: [父级]） */
  navigateToShopGroupCategory(category, ancestors = []) {
    const path = getShopGroupCategoryPath(category, ancestors);
    location.href = path;
  },

  // 接口错误文案：msg 含「格式不正确」时映射为字段级中意文提示
  apiErrorMsg(msg) {
    if (!msg) return "";
    const raw = String(msg);
    if (raw.indexOf("格式不正确") === -1) {
      return fanyi(raw);
    }
    const fieldKey = (raw.split(":")[0] || "").trim().toLowerCase();
    const isMobileField =
      ["mobile", "tel", "phone"].includes(fieldKey) ||
      raw.indexOf("电话") !== -1 ||
      raw.indexOf("手机") !== -1;
    if (isMobileField) {
      return fanyi("电话格式不正确");
    }
    return fanyi("格式不正确");
  },

  // 附加服务展示名：中文模式显示 name，意文模式显示 name_translate（不影响传参）
  optionDisplayName(option) {
    if (!option) return "";
    if (store.state.fanyi) {
      return option.name || option.name_translate || "";
    }
    return option.name_translate || option.name || "";
  },

  // 商品类别图标
  goodsCategoryIcon(type = "1688") {
    switch (type) {
      case 1688:
        return "https://rakumart-test.oss-cn-hangzhou.aliyuncs.com/20251017132103833880.svg";
      case "alibaba":
        return "https://rakumart-test.oss-cn-hangzhou.aliyuncs.com/20260410112716635020.svg";
      case "rakumart":
        return "https://rakumart-test.oss-cn-hangzhou.aliyuncs.com/20260630104725891432.svg";
      default:
        return "https://rakumart-test.oss-cn-hangzhou.aliyuncs.com/20251017132103833880.svg";
    }
  },
};
export default data;
